import { render, staticRenderFns } from "./CompareRoot.vue?vue&type=template&id=0653bd3d"
import script from "./CompareRoot.vue?vue&type=script&lang=js"
export * from "./CompareRoot.vue?vue&type=script&lang=js"
import style0 from "./CompareRoot.vue?vue&type=style&index=0&id=0653bd3d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports